const LOCAL_STORAGE_ID = "LATROBE-BAX-USER-ID";

export const getUserId = () => localStorage.getItem(LOCAL_STORAGE_ID) || "null";

export const setUserId = (uId: string) => uId && localStorage.setItem(LOCAL_STORAGE_ID, uId);
